/**
 * ReleaseTEAM footer.
 *
 * Placed on the panel screens only, never over the board or the screenshot
 * viewer — those are full-height with a fixed action bar, and a footer would
 * fight it.
 *
 * The pitch is deliberately tied to what just happened: someone who has only
 * now discovered they missed most of the problems on a real Jira screen is the
 * one person for whom "we do this for a living" is a useful sentence rather
 * than an advert.
 */
import { SoundControl } from './SoundControl';

export function SiteFooter() {
  return (
    <footer className="footer">
      <p className="footer__pitch">
        Recognise any of this on your own boards? Misconfigurations like these
        are quietly expensive — and finding them is what we do for a living.
      </p>

      <a
        className="footer__cta"
        href="https://calendly.com/releaseteaminc"
        target="_blank"
        rel="noopener noreferrer"
      >
        Book a call
      </a>

      <p className="footer__contact">
        <a href="tel:+18668870489">866-887-0489</a>
        <span aria-hidden="true"> · </span>
        <a href="mailto:info@releaseteam.com">info@releaseteam.com</a>
        <span aria-hidden="true"> · </span>
        <a href="https://www.releaseteam.com" target="_blank" rel="noopener noreferrer">
          releaseteam.com
        </a>
        <span aria-hidden="true"> · </span>
        <a href="#privacy">Privacy</a>
        <span aria-hidden="true"> · </span>
        <a href="#attribution">Attribution</a>
      </p>

      <p className="footer__sound">
        <SoundControl />
      </p>
    </footer>
  );
}
